import errorParser from '@/utils/error-parser'
import RestResourceService from "@/services/RestResourcesService";

function initialState() {
    return {
        facets: [],
        codes: [],
        dashboardSearchLoading: false,
        Configurations: [],
        currentConfig : null
    }
}

export default {
    state: initialState(),
    getters: {
        DASHBOARD_SEARCH_CODES: state => {
            return state.codes;
        },
        DASHBOARD_CONFIGURATIONS: state => {
            return state.Configurations;
        },
        DASHBOARD_CURRENT_CONFIG : state => {
            return state.currentConfig;
        },
    },
    mutations: {
        SET_DASHBOARD_SEARCH_CODES(state, payload) {
            state.codes = payload
        },
        SET_PROGRESS_LOADING(state, payload) {
            state.dashboardSearchLoading = payload;
        },
        SET_DASHBOARD_CONFIGURATIONS(state, payload) {
            state.Configurations = payload;
        },
        SET_DASHBOARD_CURRENT_CONFIGURATION(state, payload) {
            state.currentConfig = payload;
        },
    },
    actions: {
        GET_DASHBOARD_SEARCH_CODES: ({commit, dispatch}, payload) => {
            commit('SET_PROGRESS_LOADING', true);
            return RestResourceService.getResources(payload.url)
                .then((response) => {
                    commit('SET_DASHBOARD_SEARCH_CODES', response.data);
                    commit('SET_PROGRESS_LOADING', false);
                })
                .catch((error) => {
                    errorParser.parse({
                        error: error,
                        redirectTo404Page: false,
                        redirectTo500Page: false,
                        clearAuthData: false,
                        redirectToLoginPage: false,
                        showNotification: true,
                    });
                    throw new Error(error);
                })
        },
        GET_DASHBOARD_CONFIGURATIONS: async ({commit}, url) => {
            return RestResourceService.getResources(url)
                .then((response) => {
                    if(response.data.length > 0){
                        //if(localStorage.getItem(url)!='default' )
                            if(!localStorage.getItem(url) || !response.data.includes(localStorage.getItem(url)) ) {
                                localStorage.setItem(url,response.data[0])
                            }
                        }  
                    commit('SET_DASHBOARD_CONFIGURATIONS', response.data);
                })
                .catch((error) => {
                    errorParser.parse({
                        error: error,
                        redirectTo404Page: false,
                        redirectTo500Page: false,
                        clearAuthData: false,
                        redirectToLoginPage: false,
                        showNotification: false,
                    });
                    throw new Error(error);
                })

        },
        GET_DASHBOARD_CONFIGURATION: async ({commit}, payload) => {
            const getUrl = `${payload.url}/${payload.config}`;
            return RestResourceService.getResources(getUrl)
                .then((response) => {
                    commit('SET_DASHBOARD_CURRENT_CONFIGURATION',response.data);
                })
                .catch((error) => {
                    errorParser.parse({
                        error: error,
                        redirectTo404Page: false,
                        redirectTo500Page: false,
                        clearAuthData: false,
                        redirectToLoginPage: false,
                        showNotification: false
                    });
                    throw new Error(error);
                })
        },
        UPDATE_DASHBOARD_CONFIGURATION: async ({commit,dispatch}, payload) => {
            const updateUrl = `${payload.url}/${payload.name}`;
            return RestResourceService.updateResources(updateUrl,payload)
                .then((response) => {
                    dispatch('GET_DASHBOARD_CONFIGURATIONS',payload.url)
                    commit('SET_DASHBOARD_CURRENT_CONFIGURATION',payload);
                })
                .catch((error) => {
                    errorParser.parse({
                        error: error,
                        redirectTo404Page: false,
                        redirectTo500Page: false,
                        clearAuthData: false,
                        redirectToLoginPage: false,
                        showNotification: false,
                    });
                    throw new Error(error);
                })

        },
        DELETE_DASHBOARD_CONFIGURATION: async ({commit,dispatch,getters},payload) => {
            const delUrl = `${payload.url}/${payload.config}`;
            return RestResourceService.deleteResources(delUrl).then((response) => {
                    if(response){
                        dispatch('GET_DASHBOARD_CONFIGURATIONS',payload.url);}
                    /*if(getters.CURRENT_CONFIG && getters.CURRENT_CONFIG.name=== payload.config) {
                        commit('SET_DASHBOARD_CURRENT_CONFIGURATION',null);
                    }*/
                })
                .catch((error) => {
                    errorParser.parse({
                        error: error,
                        redirectTo404Page: false,
                        redirectTo500Page: false,
                        clearAuthData: false,
                        redirectToLoginPage: false,
                        showNotification: false,
                    });
                    throw new Error(error);
                })

        },
    }
}
